import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/tarifas`;

export const tarifasApi = {
  config: () => axios.get(`${API}/config`).then((r) => r.data),
  saveConfig: (body) => axios.put(`${API}/config`, body).then((r) => r.data),
  googleStatus: () => axios.get(`${API}/google/status`).then((r) => r.data),
  googleConnect: () =>
    axios.post(`${API}/google/connect`, { redirect_uri: `${process.env.REACT_APP_BACKEND_URL}/api/oauth/drive/callback` }).then((r) => r.data),
  googleDisconnect: () => axios.post(`${API}/google/disconnect`).then((r) => r.data),
  providers: () => axios.get(`${API}/providers`).then((r) => r.data),
  createProvider: (body) => axios.post(`${API}/providers`, body).then((r) => r.data),
  updateProvider: (id, body) => axios.put(`${API}/providers/${id}`, body).then((r) => r.data),
  deleteProvider: (id) => axios.delete(`${API}/providers/${id}`).then((r) => r.data),
  providersFromDrive: () => axios.post(`${API}/providers/from-drive`).then((r) => r.data),
  providerTarifas: (id) => axios.get(`${API}/providers/${id}/tarifas`).then((r) => r.data),
  aliasSuggestions: (includeAssigned = false) => axios.get(`${API}/aliases/suggestions`, { params: { include_assigned: includeAssigned } }).then((r) => r.data),
  aliasAssign: (providerId, alias, countryHint) => axios.post(`${API}/aliases/assign`, { provider_id: providerId, alias, country_hint: countryHint || null }).then((r) => r.data),
  aliasIgnore: (mark) => axios.post(`${API}/aliases/ignore`, { mark }).then((r) => r.data),
  aliasUnignore: (key) => axios.delete(`${API}/aliases/ignore/${encodeURIComponent(key)}`).then((r) => r.data),
  scan: () => axios.post(`${API}/drive/scan`).then((r) => r.data),
  files: (providerId) => axios.get(`${API}/drive/files`, { params: providerId ? { provider_id: providerId } : {} }).then((r) => r.data),
  assignFile: (id, providerId) => axios.put(`${API}/drive/files/${id}`, { provider_id: providerId }).then((r) => r.data),
  uploadFile: (file, providerId, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    if (providerId) fd.append("provider_id", providerId);
    return axios.post(`${API}/files/upload`, fd, { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress: onProgress }).then((r) => r.data);
  },
  deleteFile: (id) => axios.delete(`${API}/files/${id}`).then((r) => r.data),
  downloadUrl: (id) => `${API}/files/${id}/download`,
  syncCatalog: () => axios.post(`${API}/kimkim/sync`).then((r) => r.data),
  activities: (params) => axios.get(`${API}/kimkim/activities`, { params }).then((r) => r.data),
  lookup: (ref, providerId) => axios.get(`${API}/kimkim/lookup`, { params: { ref, provider_id: providerId || undefined } }).then((r) => r.data),
  run: (id) => axios.get(`${API}/runs/${id}`).then((r) => r.data),
  processFile: (id) => axios.post(`${API}/files/${id}/process`).then((r) => r.data),
  fileDetail: (id) => axios.get(`${API}/files/${id}`).then((r) => r.data),
  preview: (id, providerKey, kimkimId) => axios.get(`${API}/files/${id}/preview`, { params: { provider_key: providerKey, kimkim_activity_id: kimkimId } }).then((r) => r.data),
  recompute: (id) => axios.post(`${API}/files/${id}/recompute`).then((r) => r.data),
  rematch: (id) => axios.post(`${API}/files/${id}/rematch`).then((r) => r.data),
  updateCorrespondence: (id, body) => axios.put(`${API}/correspondences/${id}`, body).then((r) => r.data),
  createCorrespondence: (body) => axios.post(`${API}/correspondences`, body).then((r) => r.data),
  deleteCorrespondence: (id) => axios.delete(`${API}/correspondences/${id}`).then((r) => r.data),
  apply: (fileId, proposalIds) => axios.post(`${API}/files/${fileId}/apply`, { proposal_ids: proposalIds }).then((r) => r.data),
  applyPreview: (fileId, proposalIds) => axios.post(`${API}/files/${fileId}/apply/preview`, { proposal_ids: proposalIds }).then((r) => r.data),
  registry: () => axios.get(`${API}/registry`).then((r) => r.data),
  exportUrl: `${API}/registry/export.xlsx`,
  providerExportUrl: (id) => `${API}/providers/${id}/tarifas/export.xlsx`,
};

export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;

export const fmtMoney = (v, cur = "EUR") =>
  v === null || v === undefined ? "—" : `${Number(v).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${cur}`;

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" }) : "—");

export const tierLabel = (min, max) => (max >= 99 ? `${min}+` : min === max ? `${min}` : `${min}-${max}`);

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function pollRun(id, onUpdate, intervalMs = 2000) {
  for (;;) {
    const run = await tarifasApi.run(id);
    onUpdate?.(run);
    if (run.status === "done" || run.status === "error") return run;
    await sleep(intervalMs);
  }
}
